export default __webpack_public_path__ + "static/media/183.cdd47a23.jpg";